var map = {
	"./ConfigurationTab.vue": [
		"9c4e",
		"chunk-42cb7ff4"
	],
	"./CustomersTab.vue": [
		"6b90",
		"chunk-0b98b552"
	],
	"./LogsTab.vue": [
		"8f94",
		"chunk-d3c7aa08"
	],
	"./StatisticsTab.vue": [
		"3f1d",
		"chunk-2d0c551c"
	],
	"./UsersTab.vue": [
		"a934",
		"chunk-0b72d2a6"
	],
	"./logs-tabs/AnalyticsLogsTab.vue": [
		"4a05",
		"chunk-32b0bc5a",
		"chunk-2d0cb668"
	],
	"./logs-tabs/ModerationLogsTab.vue": [
		"1823",
		"chunk-32b0bc5a",
		"chunk-2d0abf9e"
	],
	"./logs-tabs/RateLimitLogsTab.vue": [
		"f550",
		"chunk-42df47e3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2dc9";
module.exports = webpackAsyncContext;